import { css } from '@emotion/react';

export const avatarSizeStyles = {
  xs: css`
    width: 24px;
    height: 24px;
  `,
  sm: css`
    width: 32px;
    height: 32px;
  `,
  md: css`
    width: 44px;
    height: 44px;
  `,
  lg: css`
    width: 60px;
    height: 60px;
  `,
  xl: css`
    width: 80px;
    height: 80px;
  `,
  '2xl': css`
    width: 120px;
    height: 120px;
  `,
};

export const avatarBaseStyles = css`
  border-radius: 50%;
  object-fit: cover;
  display: block;
`;

export const avatarTextStyles = css`
  border-radius: 50%;
  background-color: var(--surface-action);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  user-select: none;
`;

export const avatarFallbackStyles = css`
  border-radius: 50%;
  background-color: var(--color-neutral-100);
  color: var(--color-neutral-500);
  display: flex;
  align-items: center;
  justify-content: center;
`;
